import {
    WarningMailTipNoPermissionToSend,
    WarningMailTipNoPermissionToSendMultiple,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getGenericMessageElementAndParts } from './getGenericMessageParts';
import { MailTipsCategory } from '../datapoints';

/**
 * returns InfoBarMessageViewState for recipients for which sending mails is restricted.
 * returns null if mails are not restricted for any recipient.
 */
export default (
    recipients: EmailAddressWrapper[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!recipients.length) {
        return null;
    }
    const [messageElement, messageParts] = getGenericMessageElementAndParts(
        recipients,
        loc(WarningMailTipNoPermissionToSend),
        loc(WarningMailTipNoPermissionToSendMultiple),
        onRemoveRecipientsClick,
        MailTipsCategory.DeliveryRestricted
    );
    return {
        key: 'DeliveryRestricted',
        messageElement,
        messageParts,
        rank: InfoBarMessageRank.Error,
        source: InfoBarMessageSource.Compose,
    };
};
